export const validateMintAmount = (amount, maxMint) => {
    const mintAmount = parseInt(amount);
    if (isNaN(mintAmount) || mintAmount < 1) {
        throw new Error('Invalid mint amount');
    }
    if (mintAmount > maxMint) {
        throw new Error(`Cannot mint more than ${maxMint} tokens`);
    }
    return mintAmount;
};

export const validateChainSelection = (chainNo) => {
    if (!chainNo || chainNo < 1 || chainNo > 8) {
        throw new Error('Invalid chain selection');
    }
    return true;
};

export const validateConceptSelection = (conceptNo) => {
    if (!conceptNo || conceptNo < 1 || conceptNo > 5) {
        throw new Error('Invalid concept selection');
    }
    return true;
};